import { render } from "./g-api-call.vue?vue&type=template&id=5bf3942e&ts=true"
import script from "./g-api-call.vue?vue&type=script&lang=tsx"
export * from "./g-api-call.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__